module.exports = __webpack_public_path__ + "img/assault_tank_small.a472cef9.png";